import ExportFileMixin from "../../mixins/export-file";

Vue.component("service-providers", {

    mixins: [require("../../mixins/vuetable-css-mixin"), ExportFileMixin],

    props: ["providerTypes"],

    data () {
        return {
            searchParams: {
                filter_text: "",
                archived_filter: false,
            },
            showBulkActions: false,
            currentServiceProvider: {},
            selectedServiceProviderForInvite: {},
            showInviteDialog: false,
            inviteForm: new AppForm({
                custom_message: null,
                service_provider_id: null
            }),

            columns: [
                {
                    name: "name",
                    title: "Name",
                    sortField: "name",
                    dataClass: "text-nowrap font-medium"
                },
                {
                    name: "type",
                    dataClass: "text-nowrap",
                    sortField: "type"
                },
                {
                    name: "__slot:primary_contact",
                    title: "Primary Contact",
                    dataClass: "text-left"
                },
                {
                    name: "email",
                    title: "Company Email",
                    dataClass: "text-nowrap"
                },
                {
                    name: "phone",
                    title: "Company Phone",
                    dataClass: "text-nowrap"
                },
            ],
            importForm: new AppForm({}),
            serviceProviderImportUploadRequestHeaders: window.axios.defaults.headers.common
        };
    },

    created () {
        if (this.hasFeature("feat_service_provider_portals")) {
            this.columns.push({
                name: "__slot:invite_to_join",
                title: "",
                titleClass: "center aligned",
                dataClass: "text-right"
            });
        }

        this.columns.push({
            name: "__slot:view_service_provider",
            title: "",
            titleClass: "center aligned",
            dataClass: "text-center"
        });

        let self = this;
        Bus.$on("service-provider-created", function () {
            self.hideServiceProviderForm();
            Vue.nextTick(() => self.$refs.vuetable.refresh());
        });
    },

    computed: {
        serviceProviderImportUploadUrl () {
            return "/serviceproviders/import";
        }
    },

    methods: {
        inviteServiceProvider (selectedServiceProviderData) {
            this.selectedServiceProviderForInvite = selectedServiceProviderData;
            this.inviteForm.service_provider_id = this.selectedServiceProviderForInvite.id;
            this.showInviteDialog = true;
        },

        sendInviteEmail () {
            if (this.selectedServiceProviderForInvite.primary_contact == null || this.selectedServiceProviderForInvite.primary_contact.email == null) {
                toastr.error("This service provider doesn't have a primary contact with an email address!");
                return;
            }

            App.post("/serviceproviders/send-link-up-invite", this.inviteForm)
            .then((response) => {
                this.showInviteDialog = false;
                toastr.success("Service Provider Invited To Link Up");
                this.doFilter();
            }).catch((errors) => {
                toastr.error("Could not send invite. " + errors.message);
            });
        },

        doFilter () {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        showServiceProviderForm () {
            if (!this.verifyTeamIsSubscribed()) {
                return;
            }
            $("#modal-service-provider-form").modal("show");
        },

        hideServiceProviderForm () {
            $("#modal-service-provider-form").modal("hide");
        },

        openServiceProvider (data) {
            window.location = "/serviceproviders/" + data.id;
        },

        reloadTable () {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
            this.$refs.vuetable.selectedTo = [];
        },

        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },

        onChangePage (page) {
            this.$refs.vuetable.changePage(page);
        },

        toggleArchivedServiceProviders () {
            this.$set(this.searchParams, "archived_filter", !this.searchParams.archived_filter);
            this.doFilter();
        },

        exportServiceProviders () {
            this.$set(this.searchParams, "sort", this.$refs.vuetable?.getSortParam());
            this.exportData("/serviceproviders/export", this.searchParams, this.$dayjs().format("DD-MM-YYYY") + " Service Providers Export.xlsx");
        },

        onActionClick (action, data, index) {
            switch (action) {
                case "open-service-provider":
                    this.currentServiceProvider = data;
                    this.openServiceProvider(data);
                    break;

            }
        },

        showImportFileUploadForm () {
            $("#service-provider-import-modal").modal("show");
        },

        handleImportUploadError (error, file, fileList) {
            toastr.error("File upload failed! Please try again.");
        },

        handleImportUploadSuccess (res, file) {
            toastr.success(res);
        },
    },
});
